import React, { useEffect, useState } from "react";
import { CloudOff, RefreshCw } from "lucide-react";
import { readQueue, subscribe, syncQueue } from "@/lib/offlineQueue";
import { toast } from "sonner";

export function OfflineSync() {
  const [count, setCount] = useState(readQueue().length);
  const [online, setOnline] = useState(navigator.onLine);
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const r = await syncQueue();
      if (r.synced) toast.success(`${r.synced} offline attempt${r.synced > 1 ? "s" : ""} synced`);
    } finally { setBusy(false); }
  };

  useEffect(() => {
    const unsub = subscribe((q) => setCount(q.length));
    const on = () => { setOnline(true); run(); };
    const off = () => setOnline(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    if (navigator.onLine) run();
    return () => { unsub(); window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (online && count === 0) return null;
  return (
    <div className={`text-[11px] px-3 py-2 flex items-center gap-2 ${online ? "bg-amber-500 text-amber-950" : "bg-slate-800 text-white"}`} data-testid="offline-banner">
      {online ? <RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} /> : <CloudOff className="h-3.5 w-3.5" />}
      <span className="flex-1" data-testid="offline-banner-text">
        {online ? `${count} attempt${count > 1 ? "s" : ""} waiting to sync` : `Offline — attempts will be saved on this device${count ? ` (${count} queued)` : ""}`}
      </span>
      {online && count > 0 && <button type="button" className="underline" onClick={run} data-testid="offline-sync-now">Sync now</button>}
    </div>
  );
}
